import { isEqual } from "lodash";
import { DataTypes } from "../../../data/DataManager";
import { Site } from "../external-sources/Sites";
import { FieldSchema, FieldValues, isEmpty } from "../../../Schema";
import { Modes } from "./mode";
import { EntryTypes } from "./entryType";


export const fields4ep = [
  "linkedInstance",
  "siteName",
  "serialNumber",
  "equipmentId",
  "materialNumber",
  "inventoryNumber",
  "instrumentRUDI",
  "instrumentGTIN",
  "equipmentCategory",
  "manufacturer",
  "equipmentModel",
  "variant",
  "equipmentType",
  "description",
  "entryType",
  "cluster",
  "belongingToGroup",
  "buildingLocation",
  "floor",
  "room",
  "responsiblePerson",
  "systemOwner",
  "responsibleProxy",
  "contactPerson",
  "functionalLocation",
  "costCenter",
  "sop",
  "gxpRelevant",
  "qualificationStatus",
  "controlledEquipmentStatus",
  "dateOfLastCalibration",
  "qualificationDocuments",
  "systemStatus",
  "softwareVersion",
  "configurationBaseline",
  "configurationDetails",
  "isBookable",
  "isVisualized",
  "checkInRequired",
  "checkInStartPeriod",
  "checkInGracePeriod",
  "isHazardous",
  "shouldAssisted",
];

export const sites4ep =  ["Ludwigsburg", "Mannheim", "Penzberg"];

const prepareValuesFor4ep = (values: FieldValues): FieldValues => {
  const preparedValues: FieldValues = {};
  for (const field of fields4ep) {
    if (!isEmpty(values[field])) {
      preparedValues[field] = values[field];
    }
  }
  return preparedValues;
};

export const is4epMode: FieldSchema = {
  name: "is4epMode",
  display: {
    displayed: false
  },
  graphql: {
    selection: undefined,
  },
  dataTransform: {
    fromGraphql: false,
    // Never persisted, by either route: this exists to drive the form and the schema's
    // own cross-field logic, not to be stored.
    toGraphql: undefined,
    toDb: undefined,
  },
  data: {
    type: DataTypes.BOOLEAN,
    assignedValue: {
      getter: (values) => {
        const preparedValues = prepareValuesFor4ep(values);
        if (
          values.originalValues &&
          [Modes.EDIT, Modes.BULK_EDIT]
            .includes(values.mode as Modes)
        ) {
          const preparedInitialValues = prepareValuesFor4ep((values.originalValues ?? {}) as FieldValues);
          return Boolean(
            !isEqual(
              {...preparedInitialValues, ...preparedValues},
              preparedInitialValues
            ) &&
            String(preparedInitialValues.belongingToGroup).startsWith("DSR") &&
            sites4ep.includes(String((preparedInitialValues.siteName as Site)?.siteName)) &&
            preparedInitialValues.entryType !== EntryTypes.CLUSTER &&
            (
              preparedInitialValues.gxpRelevant === "Yes" ||
              preparedValues.gxpRelevant === "Yes"
            )
          );
        }
        if (values.mode === Modes.CREATE) {
          return String(preparedValues.belongingToGroup).startsWith("DSR") &&
            sites4ep.includes(String((preparedValues.siteName as Site)?.siteName)) &&
            preparedValues.entryType !== EntryTypes.CLUSTER;
        }
        return undefined;
      },
      fields: [...fields4ep, "mode", "originalValues"],
    }
  },
  form: {
    label: "Is 4ep mode?",
    disabled: true,
    displayed: false,
  }
};